/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

const VISITED_KEY = 'gallery_visited';

@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (localStorage.getItem(VISITED_KEY)) {
      this.router.navigate(['/products']);
    } else {
      this.router.navigate(['/installation-guide']);
    }
    return false;
  }
}
